import { BaseDataService } from './BaseDataService';
import { CharacteristicGroup, SurveyVersion, Survey, SecondaryReport } from '../../models';
import { NotificationService } from '../../services';

export class CharacteristicGroupDataService extends BaseDataService<CharacteristicGroup> {
    constructor(notificationService: NotificationService) {
        super('CharacteristicGroup', 'CharacteristicGroups', notificationService);
    }

    public getAllBySurvey(survey: Survey): Promise<any> {
        const endpoint = `${this.endpointRoot}/bysurvey/${survey.id}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }

            const message = `Error retrieving characteristic groups.`;
            this.notificationService.addError(message);
            throw new Error(message);
        });
    }

    public getAllBySurveyVersion(surveyVersion: SurveyVersion): Promise<any> {
        const endpoint = `${this.endpointRoot}/bysurveyversion/${surveyVersion.id}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }

            const message = `Error retrieving characteristic groups.`;
            this.notificationService.addError(message);
            throw new Error(message);
        });
    }

    public getAllByReport(secondaryReport: SecondaryReport): Promise<any> {
        const endpoint = `${this.endpointRoot}/bysecondaryreport/${secondaryReport.id}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }

            const message = `Error retrieving characteristic groups.`;
            this.notificationService.addError(message);
            throw new Error(message);
        });
    }
    
}


// WEBPACK FOOTER //
// ./src/services/api/CharacteristicGroupData.tsx